import React, { Component } from 'react'
import FileReactPlayer from 'react-player/lib/players/FilePlayer'

import "./DeepSingPlayer.css"
import PlayerContext from '../../playerContext';

class DeepSingPlayer extends Component {
    static contextType = PlayerContext

    componentDidMount() {
        const playerStatus = this.context
        // setInterval(function () { time++; playerStatus.setTime(time) }, 3000);
    }

    render() {
        const playerStatus = this.context

        return (
                <FileReactPlayer
                    url={`/engine/deepData/${playerStatus.storyId}.mp4`}
                    width="100%"
                    height="100%"
                    playing = {!playerStatus.paused}
                    controls
                    className = "deepPlayer"
                    onProgress ={
                        ({ played, playedSeconds, loaded, loadedSeconds }) => {
                            playerStatus.setCurrentSeconds(playedSeconds);
                        }
                    }

                    onSeek ={
                        (seconds) => {
                            console.log(seconds);
                            playerStatus.setSeekSeconds(seconds);
                        }
                    }

                    onPause ={
                        () => {
                            playerStatus.setPaused(true);
                        }
                    }

                    onPlay ={
                        () => {
                            playerStatus.setPaused(false);
                        }
                    }

                    onReady={
                        () => {
                            console.log("Deep ready")
                            // playerStatus.setPaused(false);
                        }
                    }
                />
        )
    }
}

export default DeepSingPlayer